export const VERSION = '0.6.4';
